<template>
  <div class="tax_details">
<div class="card-panels pt-0">
  <div @click="updateErrorMsg()" class="text-danger text-sm formerrors " v-if="checkProperty($store.state, 'taxReturnsErrMsg')">
    <vs-alert color="warning"  class="warning-alert reg-warning-alert no-border-radius"  icon-pack="IntakePortal"  icon="IP-information-button"
      active="true">{{ checkProperty($store.state, 'taxReturnsErrMsg') }}
    </vs-alert>
  </div>
<div class="actions-btn-list actions-btn-listv2"> 
  <div></div>
<ul >
  <li> 
    <span   class="items_edit" @click="updateTaxReturns(true);updateErrorMsg() ">
      <img src="@/assets/images/main/icon-edit.svg" />
      <template  v-if="taxReturnList&&taxReturnList.length > 0">Edit</template>
      <template v-else>Update</template>
    </span>
  </li>
</ul>

</div>

      <div >
        <div class="accordian-table filingdata_table filingdata_table_v2 pad">
          
          <template  v-if="taxReturnList&&taxReturnList.length > 0">
              <vs-table :data="taxReturnList" class="fees_table padt10 "> 
                <template slot="thead">
                  <vs-th>
                    Tax Returns For Year   
                  </vs-th>
                  <vs-th>
                    Gross Income 
                  </vs-th>
                  <vs-th >
                    Net Income
                  </vs-th> 
                  <vs-th >
                    Documents
                  </vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr v-for="taxItem in data" :key="taxItem">
                    <vs-td>
                       {{ checkProperty(taxItem, 'year') }}
                    </vs-td>
                    <vs-td v-if=" checkProperty(taxItem, 'grossIncome')">
                      {{formatprice(taxItem.grossIncome)}}
                    </vs-td>
                    <vs-td v-else>
                      {{'-'}}
                      </vs-td>
                    <vs-td v-if=" checkProperty(taxItem, 'netIncome')">
                      {{formatprice(taxItem.netIncome)}}
                    </vs-td>
                    <vs-td v-else>
                      {{'-'}}
                      </vs-td>
                    <vs-td>
                      <template>
       <div class="px-6">
        <documentsView @download_or_view="download_or_view" :type="'Cheques'" :documentsList="taxItem['document']" />
       </div>
      </template>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
          </template>
            <template> 
              <NoDataFound ref="NoDataFoundRef"  v-if="taxReturnList.length == 0 " content="" heading="No Results Found" type='Email' />
            </template>
         
          
        </div>

        

      </div>
      <modal
      name="taxReturnsModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="800px"
      height="auto"
    >
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Tax Returns</h2>
          <span @click="hideTaxReturnModal">
            <em class="material-icons">close</em> 
          </span>
        </div>
        <form  data-vv-scope="taxReturnform" @submit.prevent>
          <div class="form-container"  @click="taxReturnformerrors = ''" >
            <div class="filing_fields w-100">
              <template>
                
                <div class="form-container pt-2 filingform_table">
                <div class="vx-row" >
                  <div class="vx-col w-full">
                    <div class="pre_defined_sec filingFee_table" v-for="(taxItem ,index) in taxReturnList">
                     <vs-table :data="taxItem">
                      <template>
                        <vs-tr>
                          <vs-td class="pad0" colspan="3">
                            <h4 class="small-header">Tax Returns For {{checkProperty(taxItem, 'year')}}</h4>
                          </vs-td>
                        </vs-tr> 
                        <tbody>
                          <vs-tr  class="vs-table--tr" >
                    
                            <vs-td>
                              <div class="comments_sec comments_secV2 mb-0" >
                                <label class="form_label">Gross Income<em>*</em></label>
                                    <vs-input
                                    data-vv-as="Amount"
                                    v-validate="'required'"
                                    v-model="taxItem.grossIncome"
                                    :name="'grossIncome'+index"
                                    v-mask="'#####'"
                                    class="amount_input input_prefix"
                                  />
                                  <span
                                    class="text-danger text-sm"
                                    v-show="errors.has('taxReturnform.grossIncome'+index)"
                                    >{{ errors.first("taxReturnform.grossIncome"+index) }}
                                  </span>
                              </div>
                            </vs-td>
                            <vs-td>
                            
                            <div class="comments_sec comments_secV2 mb-0" >
                              <label class="form_label">Net Income<em>*</em></label>
                                  <vs-input
                                  data-vv-as="Amount"
                                  v-validate="'required'"
                                  v-model="taxItem.netIncome"
                                  :name="'netIncome'+index"
                                  v-mask="'#####'"
                                  class="amount_input input_prefix"
                                />
                                <span
                                  class="text-danger text-sm"
                                  v-show="errors.has('taxReturnform.netIncome'+index)"
                                  >{{ errors.first("taxReturnform.netIncome"+index) }}
                                </span>
                            </div>
                          </vs-td>
                            <div class="vx-col w-full" @click="value = [];uploading=false;DocErr=false">
                    <div class="form_group file_group mb-0">
                      <div class="vs-component marb10">
                        <label class="form_label">Document<em></em></label>
                        <div class="relative">
                          <file-upload v-model="taxItem.document" class="file-upload-input upload_file justify-center"
                            :accept="allDocEntity"
                            :name="'Documents'+index" :multiple="false" :hideSelected="true" 
                            >
                            <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                            Upload
                          </file-upload>
                          <span class="text-danger text-sm"
                           v-show="errors.has('Documents'+index)">{{ '*Documents are required' }}</span>
                        </div>
                      </div>
                      <ul class="uploaded-list note_uploads">
                        <template v-for="(item, ind) in taxItem['document']">
                          <vs-chip @click="remove(item, taxItem['document'],ind)" :key="ind" closable>
                            <img src="@/assets/images/main/down-arrow2.svg" @click="download_or_view(item)" />
                            {{ item.name }}
                          </vs-chip>
                        </template>
                      </ul>
                    </div>
                  </div>
                          </vs-tr>  
                        </tbody>
                          
                           
                      </template>
                     </vs-table>
                  
              
                    </div>
                  </div>
                  
                </div>
              </div>
              </template>
            </div>       
          </div>
          <div class="text-danger text-sm formerrors"  v-if="taxReturnformerrors!=''">
            <vs-alert
              color="warning"
              class="warning-alert reg-warning-alert no-border-radius"
              icon-pack="IntakePortal"
              icon="IP-information-button"
              active="true"
              >{{ taxReturnformerrors }}</vs-alert
            >
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="submitingTaxReturnsLoading"
              ><img src="@/assets/images/main/loader.gif"
            /></span>
            <vs-button
              color="dark"
              @click="hideTaxReturnModal"
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
            <vs-button
              color="success"
              @click="updateTaxReturnsAction"
              class="save"
              type="filled"
            >
              Update</vs-button
            >
            
          </div>
        </form>
      </div>
    </modal>
     <petitionerTaxPopup
     v-if="showTaxReturnPopup"
     :petition="petition"
     @hidePopup="hideTaxReturnModal"/>
      
      
    </div>
    </div>
</template>

<script>
import documentsView from "@/views/common/documentsView.vue";
const formatter = new Intl.NumberFormat("en-US", {
style: "currency",
currency: "USD",
minimumFractionDigits: 2
});


import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NoDataFound from "@/views/common/noData.vue";
import _ from "lodash";
import docmentType from "@/views/common/docType.vue";
import FileUpload from "@/views/FileUpload.vue";
import petitionerTaxPopup from "../actionpopups/petitionerTaxPopup.vue";
export default {
computed:{
 
},
props: {
  loadedFromPreview:false,
   currentRole:null,
   currentUser:null,
  petition: {
    type: Object,
    default: null
  },
  workFlowDetails: {
    type: Object,
    default: null,
  },
},
components: {
  documentsView,
  FileUpload,
  VuePerfectScrollbar,
  NoDataFound,
  docmentType,
  petitionerTaxPopup
},

watch: {
},
methods: {
  updateErrorMsg(){
      this.$store.commit('updateTaxReturnsErrMsg','');
    },
  updateTaxReturnsAction(){
let postData={
  'companyId':this.checkProperty(this.petition,'companyId'),
  //'taxReturnYears':[]
}
if(this.checkProperty(this.taxReturnList,'length')>0){
  postData['taxReturnYears']=this.taxReturnList
}
let path='company/update-tax-return-years'
this.taxReturnformerrors=''
 this.submitingTaxReturnsLoading=true
    this.$store.dispatch('commonAction', {"data":postData ,"path":path}).then((response) => {
      this.submitingTaxReturnsLoading=false
      this.showToster({ message: response.message, isError: false });
      this.hideTaxReturnModal()
   
      }).catch((error)=>{
        this.submitingTaxReturnsLoading=false
        this.taxReturnformerrors=error.message
        //this.showToster({ message: response.message, isError: tr });

      })
  },
  remove(item, data, filindex) {
       data.splice(filindex, 1);
       this.removeFileFromS3(item)
    },
  hideTaxReturnModal(){
    this.getTaxDetails()
    this.showTaxReturnPopup=false
    //this.$modal.hide('taxReturnsModal')
  },
  
  download_or_view(item){
   // alert();
    this.$emit('download_or_view',item);
  },
    formatprice(amount) {
    return formatter.format(amount);
  },
  updateTaxReturns(action=true) {
    //this.$modal.show('taxReturnsModal')
     this.showTaxReturnPopup=true


  },
  updateTaxReturnsforPetitioner(){
    this.isPetitionerTaxPopup=true
  }
  ,
  
  getTaxDetails(){
let postData={
  'companyId':this.checkProperty(this.petition,'companyId')
}
let path='company/details'
    this.$store.dispatch('commonAction', {"data":postData ,"path":path}).then((response) => {
        if(this.checkProperty(response,'taxReturnYears','length')>0){
           this.taxReturnList=response['taxReturnYears']
        }
        this.updateLoading(false);
        setTimeout(()=>{
          this.updateLoading(false);
        },10)
    //     else{
    //       this.taxReturnList=[{
		// 	'year': 2020,
		// 	'grossIncome': "100.25",
		// 	'netIncome': "1000.33",
		// 	'document': [
    //   			{
		// 		"name": "Masters-V1-Beneficiary 1",
		// 		"typeId": 2,
		// 		"path": "https://s3.ap-south-1.amazonaws.com/immibox/innvectra/private/0/7/4/07445e8040a711ecaba8e5b2f42d1dba.pdf",
		// 		"mimetype": "application/pdf",
		// 		"extn": "pdf"		
    // 			}
		// 	]
		// },{
		// 	'year': 2021,
		// 	'grossIncome': "100.25",
		// 	'netIncome': "1000.33",
		// 	'document': [
    //   			{
		// 		"name": "Masters-V1-Beneficiary 2",
		// 		"typeId": 2,
		// 		"path": "https://s3.ap-south-1.amazonaws.com/immibox/innvectra/private/0/7/4/07445e8040a711ecaba8e5b2f42d1dba.pdf",
		// 		"mimetype": "application/pdf",
		// 		"extn": "pdf"		
    // 			}
		// 	]
		// }]
    //     }
      }).catch((error)=>{
        this.updateLoading(false);
        setTimeout(()=>{
          this.updateLoading(false);
        },10)
      })
  }
},
data: () => ({
submitingTaxReturnsLoading:false,
taxReturnList:[],
taxReturnformerrors:'',
showTaxReturnPopup:false
}),
mounted() {   
  this.getTaxDetails()
}
};
</script>